<template>
  <g>
    <path
      d="M4.89478 19.0716C4.89478 20.1367 5.74308 21.0002 6.78951 21.0002H17.2106C18.257 21.0002 19.1053 20.1367 19.1053 19.0716V4.92875C19.1053 3.86363 18.257 3.00018 17.2106 3.00018H10.0453C9.68197 3.00018 9.33626 3.1594 9.09644 3.43718L5.20909 7.9397C5.00651 8.17434 4.89478 8.47604 4.89478 8.78841V19.0716Z"
      fill="white"
    />
    <path
      d="M4.89478 19.0716C4.89478 20.1367 5.74308 21.0002 6.78951 21.0002H17.2106C18.257 21.0002 19.1053 20.1367 19.1053 19.0716V4.92875C19.1053 3.86363 18.257 3.00018 17.2106 3.00018H10.0453C9.68197 3.00018 9.33626 3.1594 9.09644 3.43718L5.20909 7.9397C5.00651 8.17434 4.89478 8.47604 4.89478 8.78841V19.0716Z"
      fill="url(#paint0_linear_939_1083)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.39478 19.0716C4.39478 20.4045 5.45863 21.5002 6.78951 21.5002H17.2106C18.5415 21.5002 19.6053 20.4045 19.6053 19.0716V4.92875C19.6053 3.59587 18.5415 2.50018 17.2106 2.50018H10.0453C9.53495 2.50018 9.05167 2.72392 8.71797 3.11043L4.83063 7.61294C4.54898 7.93916 4.39478 8.35708 4.39478 8.78841V19.0716ZM6.78951 20.5002C6.02753 20.5002 5.39478 19.869 5.39478 19.0716V8.78841C5.39478 8.595 5.46403 8.40952 5.58755 8.26645L9.4749 3.76393C9.62085 3.59488 9.82899 3.50018 10.0453 3.50018H17.2106C17.9726 3.50018 18.6053 4.1314 18.6053 4.92875V19.0716C18.6053 19.869 17.9726 20.5002 17.2106 20.5002H6.78951Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.36846 7.80371H4.89478V8.80371H8.36846C9.35053 8.80371 10.1316 7.99584 10.1316 7.018V3.00014H9.13162V7.018C9.13162 7.46031 8.78164 7.80371 8.36846 7.80371Z"
      fill="#3E7DC0"
    />
    <g filter="url(#filter0_d_939_1083)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8948 7.50018C11.8948 7.22404 12.1186 7.00018 12.3948 7.00018H14.3948C14.6709 7.00018 14.8948 7.22404 14.8948 7.50018C14.8948 7.77633 14.6709 8.00018 14.3948 8.00018H12.3948C12.1186 8.00018 11.8948 7.77633 11.8948 7.50018Z"
        fill="#3E7DC0"
      />
    </g>
    <g filter="url(#filter1_d_939_1083)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8948 10.5002C11.8948 10.224 12.1186 10.0002 12.3948 10.0002H16.3948C16.6709 10.0002 16.8948 10.224 16.8948 10.5002C16.8948 10.7763 16.6709 11.0002 16.3948 11.0002H12.3948C12.1186 11.0002 11.8948 10.7763 11.8948 10.5002Z"
        fill="#3E7DC0"
      />
    </g>
    <rect x="1.5" y="14.0002" width="21" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M8.37109 18.1057C8.37109 18.7437 8.18229 19.2372 7.80469 19.5861C7.42969 19.9325 6.89583 20.1057 6.20312 20.1057H5.76953V22.0002H4.22656V16.2892H6.20312C6.92448 16.2892 7.46615 16.4468 7.82812 16.7619C8.1901 17.077 8.37109 17.5249 8.37109 18.1057ZM5.76953 18.8478H6.05078C6.28255 18.8478 6.46615 18.7827 6.60156 18.6525C6.73958 18.5223 6.80859 18.3426 6.80859 18.1135C6.80859 17.728 6.59505 17.5353 6.16797 17.5353H5.76953V18.8478Z"
      fill="#F8F8F8"
    />
    <path
      d="M13.4258 18.1057C13.4258 18.7437 13.237 19.2372 12.8594 19.5861C12.4844 19.9325 11.9505 20.1057 11.2578 20.1057H10.8242V22.0002H9.28125V16.2892H11.2578C11.9792 16.2892 12.5208 16.4468 12.8828 16.7619C13.2448 17.077 13.4258 17.5249 13.4258 18.1057ZM10.8242 18.8478H11.1055C11.3372 18.8478 11.5208 18.7827 11.6562 18.6525C11.7943 18.5223 11.8633 18.3426 11.8633 18.1135C11.8633 17.728 11.6497 17.5353 11.2227 17.5353H10.8242V18.8478Z"
      fill="#F8F8F8"
    />
    <path
      d="M19.7734 22.0002H17.75L15.6641 17.9767H15.6289C15.6784 18.6096 15.7031 19.0926 15.7031 19.426V22.0002H14.3359V16.2892H16.3516L18.4297 20.258H18.4531C18.4167 19.6825 18.3984 19.2202 18.3984 18.8713V16.2892H19.7734V22.0002Z"
      fill="#F8F8F8"
    />
    <defs>
      <filter
        id="filter0_d_939_1083"
        x="7.89478"
        y="7.00018"
        width="11"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1083"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1083"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_939_1083"
        x="7.89478"
        y="10.0002"
        width="13"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1083"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1083"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_939_1083"
        x1="14.8948"
        y1="3.00018"
        x2="14.8948"
        y2="19.5002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
